import { render, staticRenderFns } from "./virtualAccountComponent.vue?vue&type=template&id=05fe21c2&"
import script from "./virtualAccountComponent.vue?vue&type=script&lang=js&"
export * from "./virtualAccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports